import OnboardingRoutesWithProvider, {
  type FeatureHighlightStyles,
} from '@leagueplatform/onboarding';
import { TENANT_ID } from 'common/constants';
import { getFeatureHighlightsContentfulId } from 'common/env';

const featureHighlightStyles: FeatureHighlightStyles = {
  desktopMainPanelStyles: {
    paddingInline: '$five',
    button: { paddingBottom: '$one' },
  },
  desktopCopyContainerStyles: { width: '100%' },
  mobileTextBlockStyles: {
    paddingInline: '$oneAndHalf',
    h2: {
      fontSize: '$headingTwo',
      lineHeight: '$headingTwo',
    },
  },
  mobileSlideHeaderStyles: {
    '&:before': {
      backgroundColor: '$surfaceBackgroundPrimary',
      borderRadius: 0,
    },
  },
};

export const OnboardingFeatureHighlights = ({
  onOnboardingComplete,
}: {
  onOnboardingComplete: (error?: Error) => void;
}) => (
  <div className="onboarding-highlights">
    <OnboardingRoutesWithProvider
      contentfulId={getFeatureHighlightsContentfulId()}
      tenantId={TENANT_ID}
      onOnboardingComplete={onOnboardingComplete}
      centerIllustration
      featureHighlightStyles={featureHighlightStyles}
    />
  </div>
);
